import { render, staticRenderFns } from "./processSafetyReportFolder.vue?vue&type=template&id=38cfab5e"
import script from "./processSafetyReportFolder.vue?vue&type=script&lang=js"
export * from "./processSafetyReportFolder.vue?vue&type=script&lang=js"
import style0 from "./processSafetyReportFolder.vue?vue&type=style&index=0&id=38cfab5e&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cfab5e')) {
      api.createRecord('38cfab5e', component.options)
    } else {
      api.reload('38cfab5e', component.options)
    }
    module.hot.accept("./processSafetyReportFolder.vue?vue&type=template&id=38cfab5e", function () {
      api.rerender('38cfab5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/opm/processSafetyReportFolder.vue"
export default component.exports